import React, { useState } from 'react'
import classNames from 'classnames'
import styles from './SegmentedControl.module.sass'

type Segment = {
  label: string
  value: string
}

type SegmentedControlProps = {
  className?: string
  selected_default: string
  segments: Segment[]
  /**
   * Callback function for when the Control button is clicked.
  */
  onChange?: (value: string) => void
}

export const SegmentedControl: React.FC<SegmentedControlProps> = ({
  className,
  selected_default,
  segments,
  onChange,
}) => {
  const [selected, setSelected] = useState(selected_default)

  const handleClick = (value: string) => {
    setSelected(value)
    if (onChange) {
      onChange(value)
    }
  }

  return (
    <div className={classNames(className, styles.segmentedControl)}>
      {segments.map(({ label, value }) => (
        <div
          key={value}
          className={classNames(styles.segment, {
            [styles.selected]: selected === value,
          })}
          onClick={() => handleClick(value)}
        >
          {label}
        </div>
      ))}
    </div>
  )
}
